import React from "react";
import { useNavigate } from "react-router-dom";
import SearchIcon from "../../../../img/search-icon.png";
import backIcon from "../../../../img/Arrow.png";
const TitleBar = () => {
  const navigate = useNavigate();
  return (
    <div className="cartTitleBar fixed-top d-flex align-items-center transition text-orange bg-white ">
      <div
        onClick={() => navigate(-1)}
        className="backIcon text-center my-auto"
      >
        <img src={backIcon} alt="ICON" width={24} />
      </div>
      <div className="w-100 my-auto overflow-hidden">
        <h2>Check Order</h2>
        <h5>Rashan Point</h5>
      </div>
      <div className="SearchIcon text-center d-flex justify-content-evenly my-auto ms-auto ">
        <img
          src={SearchIcon}
          alt="ICON"
          width={22}
          className="d-block"
          onClick={() => navigate(`/search`)}
        />
      </div>
    </div>
  );
};

export default TitleBar;
